import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PT from 'prop-types';
import fetch from 'isomorphic-fetch';
/**
 * This component allows you to easily fetch a server side data payload
 * and pass it as a property to the child component, along with a loading
 * boolean
 */

export var WithData =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WithData, _React$Component);

  function WithData() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, WithData);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithData)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: false
    });

    _defineProperty(_assertThisInitialized(_this), "fetch", function () {
      var _this$props = _this.props,
          url = _this$props.url,
          method = _this$props.method,
          body = _this$props.body,
          valuesForState = _this$props.valuesForState,
          onData = _this$props.onData;
      var baseState = {
        url: url,
        method: method,
        body: body
      }; // If you want to cache results, use onData and valuesForState to
      // store it in redux or similar.

      if (valuesForState) {
        var rz = valuesForState(baseState);

        if (rz && rz.data) {
          _this.setState(_objectSpread({}, baseState, {
            data: rz.data,
            status: rz.status || 200
          }));

          return;
        }
      }

      var headers = {
        'Request-Source': 'ajax'
      };

      if (body) {
        headers['Content-Type'] = 'application/json';
      }

      fetch(url, {
        credentials: 'include',
        method: method,
        body: body ? JSON.stringify(body) : undefined,
        headers: headers
      }).then(function (response) {
        return new Promise(function ($return, $error) {
          var data;
          return Promise.resolve(response.json()).then(function ($await_1) {
            try {
              data = $await_1;

              _this.setState(_objectSpread({}, baseState, {
                data: data,
                status: response.status,
                loading: false
              }), function () {
                if (onData) {
                  onData(baseState, data);
                }
              });

              return $return();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        });
      }).catch(function (error) {
        _this.setState(_objectSpread({}, baseState, {
          error: error,
          status: error.status,
          loading: false
        }));
      });

      _this.setState(_objectSpread({}, baseState, {
        loading: true
      }));
    });

    return _this;
  }

  _createClass(WithData, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          url = _this$props2.url,
          autoLoad = _this$props2.autoLoad;
      var loading = this.state.loading;

      if (url && autoLoad && !('data' in this.state) && !loading) {
        this.fetch();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref, nextState) {
      var body = _ref.body,
          url = _ref.url;
      var _this$props3 = this.props,
          pUrl = _this$props3.url,
          pBody = _this$props3.body;
      return url !== pUrl || body !== pBody || nextState !== this.state;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref2) {
      var body = _ref2.body,
          url = _ref2.url;
      var newBody = body ? JSON.stringify(body) : null;
      var _this$props4 = this.props,
          pBody = _this$props4.body,
          pUrl = _this$props4.url,
          autoLoad = _this$props4.autoLoad;
      var exBody = pBody ? JSON.stringify(pBody) : null;

      if (autoLoad && (newBody !== exBody || url !== pUrl)) {
        this.fetch();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children && React.cloneElement(children, _objectSpread({}, this.state, {
        fetch: this.fetch
      }));
    }
  }]);

  return WithData;
}(React.Component);
WithData.defaultProps = {
  children: null,
  url: null,
  method: 'POST',
  body: null,
  autoLoad: true,
  onData: null,
  valuesForState: null
};